//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moneyFormat from '../../../util/moneyFormat.js';
import PlanClient from '../../../clients/robox-api/PlanClient.js';

const PlanSchoolCard =  {
    name: 'PlanSchoolCard',
    props: {
        planDisplay: {
            type: Object,
            required: true,
        },
        cardNumber: {
            type: Number,
            required: true,
        },
    },
    data: () => {
        return {
            plan: {},
            userInterface: {
                typeCards: [
                    'single',
                    'family',
                    'family-plus',
                    'library',
                ],
                mascots: [
                    './choose-plan-single.png',
                    './choose-plan-family.png',
                    './choose-plan-family-plus.png',
                    './choose-plan-library.png',
                ],
            },
        };
    },
    computed: {
        active: {
            get: function () {
                return this.planDisplay.school_plan_active
            },
        },
        ui: {
            get: function () {
                return {
                    cardType: `plan-${this.userInterface.typeCards[this.cardNumber]}`,
                    mascotsUri: this.assetsImages(this.userInterface.mascots[this.cardNumber]),
                };
            },
        },
        planId: {
            get: function () {
                return this.planDisplay.school_plan_id
            },
        },
        title: {
            get: function () {
                return this.planDisplay.school_title;
            },
        },
        subtitle: {
            get: function () {
                return this.planDisplay.school_subtitle;
            },
        },
        amount: {
            get: function () {
                return this.plan.price;
            },
        },
        feeAmount: {
            get: function () {
                let amount = this.amount;

                if (this.planDisplay.school_split_value) {
                    amount = Math.ceil(this.amount / this.plan.orders_by_purchase);
                }

                return amount;
            },
        },
        amountReal: {
            get: function () {
                return moneyFormat(this.feeAmount).slice(0, -3);
            },
        },
        amountCents: {
            get: function () {
                return this.feeAmount.toString().slice(-2);
            },
        },
        period: {
            get: function () {
                let titlePeriod = '';

                if (this.planDisplay.school_time_unit_name.length > 0) {
                    titlePeriod = this.planDisplay.school_time_unit_name;
                } else if (this.planDisplay.school_split_value) {
                    titlePeriod = 'mês';
                } else {
                    if (this.plan.billing_cycles === null) {
                        switch (this.plan.interval_count) {
                            case 1:
                                titlePeriod = 'mês';
                                break;
                            case 6:
                                titlePeriod = 'semestre';
                                break;
                            case 12:
                                titlePeriod = 'ano';
                                break;
                        }
                    } else {
                        titlePeriod = 'mês';
                    }
                }

                titlePeriod = (titlePeriod.search('/') !== -1) ? titlePeriod : `/${titlePeriod}`;

                return titlePeriod;
            },
        },
        ctaUrl: {
            get: function () {
                return this.planDisplay.school_cta_url;
            },
        },
        ctaTitle: {
            get: function () {
                return this.planDisplay.school_cta_title;
            },
        },
        itemsList: {
            get: function () {
                return this.planDisplay.school_items_list
                    .map(function (value) {
                        return value.school_item;
                    });
            },
        },
    },
    methods: {
        readPlan: function () {
            const self = this;

            if (self.active) {
                new PlanClient()
                    .read(self.planDisplay.school_plan_id)
                    .then(response => response.json())
                    .then(data => self.plan = data.attributes);
            }
        },
        redirectToCheckout: function () {
            window.location.href = `/flow/?plan_id=${this.planId}`;
        },
        assetsImages:function (srcImage) {
            return window.assetsImages(srcImage);
        },
    },
    created () {
        this.readPlan();
    },
};

export default PlanSchoolCard;



// WEBPACK FOOTER //
// ./scripts/vue/template-school/choose-plan-school/PlanSchoolCard.vue